import MoreVertIcon from '@mui/icons-material/MoreVert'
import { FormGroup, IconButton } from '@mui/material'
import { FlexGrowRow, FlexRow } from '@xylabs/sdk-react'
import React from 'react'

import { AppSettingsLoader, PlayMapSettings } from '../../../Contexts'
import Setting from './Setting'

interface Props {
  onChange: (settings: PlayMapSettings) => void
}

const MapSettings: React.FC<Props> = (props) => {
  const { onChange } = props

  console.log('MapSettings: Render')

  return (
    <FlexGrowRow bottom={36} left={10} position="absolute">
      <AppSettingsLoader>
        <FlexRow paper paddingX={2}>
          <FormGroup row>
            <Setting label="Grid" field="grid" defaultValue={true} onChange={onChange} />
            <Setting label="TileVectors" field="tileVectors" onChange={onChange} />
            <Setting label="Geotokens" field="geotokens" onChange={onChange} />
            <Setting label="Quadkeys" field="quadkeys" defaultValue={true} onChange={onChange} />
            <Setting dev={true} label="Assay" field="assay" onChange={onChange} />
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          </FormGroup>
        </FlexRow>
      </AppSettingsLoader>
    </FlexGrowRow>
  )
}

export default MapSettings
